import styled from "styled-components";

/**
 * Wrapper do DatePickerWithInput (Desktop)
 * Define a posição relativa e largura do componente principal.
 */
export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
/**
 * Container do campo de entrada (Desktop)
 * Estiliza o campo principal com padding e estilos flexíveis.
 */
export const InputContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding-left: ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(0.5)};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  flex-wrap: wrap;
  cursor: pointer;
  display: flex;
  min-height: ${({ theme }) => theme.spacing(6)};
  align-items: center; /* 👈 Isso centraliza os itens verticalmente */

  &::placeholder {
    font-weight: ${({ theme }) => theme.fontWeights.normal};
    color: ${({ theme }) => theme.colors.mediumGray};
  }
`;
/**
 * Placeholder do campo de entrada
 * Estiliza o texto exibido quando nenhuma data é selecionada.
 */
export const Placeholder = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  color: ${({ theme }) => theme.colors.mediumGray};
  font-size: ${({ theme }) => theme.fontSizes.md};
`;

/**
 * Ícone de hover
 * Ícone exibido quando o usuário passa o mouse sobre uma data selecionada.
 */
export const HoverIcon = styled.div`
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  display: none;
  opacity: 0.9;
`;

/**
 * Badge de data selecionada (Desktop)
 * Estiliza as datas selecionadas como badges interativos.
 */
export const SelectedDate = styled.div.withConfig({
  shouldForwardProp: (prop) => !["type"].includes(prop),
})<{ type: string }>`
  background-color: ${({ type, theme }) =>
    type === "destination" ? theme.colors.mediumBlue : theme.colors.yellow};
  border-radius: ${({ type, theme }) =>
    type === "destination"
      ? `${theme.spacing(0.5)} ${theme.spacing(0.5)} ${theme.spacing(0.5)} ${theme.spacing(0.1)}`
      : `${theme.spacing(0.5)} ${theme.spacing(0.1)} ${theme.spacing(0.5)} ${theme.spacing(0.5)}`};
  color: ${({ theme }) => theme.colors.black};
  padding: ${({ theme }) => theme.spacing(0.75)}
    ${({ theme }) => theme.spacing(1.25)};
  font-size: ${({ theme }) => theme.spacing(1.75)};
  transition: all 0.1s ease-in-out;
  text-transform: uppercase;
  flex-direction: column;
  align-items: center;
  position: relative;
  line-height: 1.2;
  cursor: pointer;
  display: flex;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightRed};
    color: ${({ theme }) => theme.colors.lightRed};

    ${HoverIcon} {
      display: flex;
    }

    & > svg {
      width: 0;
      height: 0;
    }
  }

  & > svg {
    top: ${({ type }) => (type === "destination" ? "" : "0")};
    right: ${({ type }) => (type === "destination" ? "" : "0")};
    bottom: ${({ type }) => (type === "destination" ? "0" : "")};
    left: ${({ type }) => (type === "destination" ? "0" : "")};
    width: ${({ theme }) => theme.spacing(1)};
    height: ${({ theme }) => theme.spacing(1)};
    transition: all 0.3s ease-in-out;
    position: absolute;
    stroke-width: 1.5;
  }

  & * {
    cursor: inherit;
  }
`;
